module.exports = __webpack_public_path__ + "img/statistics.3394786a.svg";